import { ContabilGatewayError } from "@/features/contabil/diagnostico/config/ContabilGatewayError";
import {
  ControleDebitosParams,
  IControleDebitosPorEmpresaGateway,
  IControleDebitosResponseItem
} from "../ports/ControleDebitosPorEmpresaGateway";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import Result from "@/core/common/Result";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import "reflect-metadata";

@injectable()
export class ControleDebitosPorEmpresaGatewayAdapter
  extends ContabilGatewayError
  implements IControleDebitosPorEmpresaGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private readonly httpClient!: HttpClient;

  async get(
    params: ControleDebitosParams
  ): Promise<Result<IControleDebitosResponseItem>> {
    try {
      const response = await this.httpClient.get<
        IDefaultContabilResponse<IControleDebitosResponseItem>
      >({
        url: `contabil/v1/empresa/${params.empresaId}/debitos-simples`
      });

      if (this.hasError(response)) {
        return Result.fail("Não foi possível buscar os débitos");
      }

      return Result.ok(response.body?.result);
    } catch (_e) {
      return Result.fail(this.DEFAULT_ERROR);
    }
  }
}
